<template>
    <div class="buttons-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Colors Grid</h3>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left grapefruit-light"></div>
                                <div class="color-right grapefruit-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Grapefruit</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left bittersweet-light"></div>
                                <div class="color-right bittersweet-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Bittersweet</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left sunflower-light"></div>
                                <div class="color-right sunflower-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Sunflower</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left grass-light"></div>
                                <div class="color-right grass-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Grass</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left mint-light"></div>
                                <div class="color-right mint-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Mint</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left aqua-light"></div>
                                <div class="color-right aqua-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Aqua</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left blueJeans-light"></div>
                                <div class="color-right blueJeans-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>BlueJeans</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left lavander-light"></div>
                                <div class="color-right lavander-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Lavander</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left pinkrose-light"></div>
                                <div class="color-right pinkrose-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Pink Rose</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left lightgray-light"></div>
                                <div class="color-right lightgray-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Light Gray</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left mediumgray-light"></div>
                                <div class="color-right mediumgray-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Medium Gray</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="color-box mb-24">
                            <div class="d-flex">
                                <div class="color-left darkgray-light"></div>
                                <div class="color-right darkgray-dark"></div>
                            </div>
                            <div class="color-text">
                                <h1>Dark Gray</h1>
                                <p>#ED5565 #DA4453</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Colors Text</h3>
                </div>

                <p class="text-primary">.text-primary</p>
                <p class="text-secondary">.text-secondary</p>
                <p class="text-success">.text-success</p>
                <p class="text-danger">.text-danger</p>
                <p class="text-warning bg-dark">.text-warning</p>
                <p class="text-info bg-dark">.text-info</p>
                <p class="text-light bg-dark">.text-light</p>
                <p class="text-dark">.text-dark</p>
                <p class="text-body">.text-body</p>
                <p class="text-muted">.text-muted</p>
                <p class="text-white bg-dark">.text-white</p>
                <p class="text-black-50">.text-black-50</p>
                <p class="text-white-50 bg-dark">.text-white-50</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorsContent'
}
</script>

<style lang="scss">
.color-box {
	background-color: var(--white-color);
	box-shadow: var(--box-shadow);
	border-radius: 5px;
	text-align: center;
	.color-text {
		padding: 20px 30px;
		h1 {
			font-weight: 500;
			font-size: 15px;
			color: var(--heading-color);
		}
		p {
			font-size: 11px;
		}
	}
	.color-left {
		width: 50%;
		height: 200px;
		background-color: #000;
		border-top-left-radius: 5px;
		display: block;
	}
	.color-right {
		width: 50%;
		height: 200px;
		background-color: #000;
		border-top-right-radius: 5px;
		display: block;
	}
}

/* Grapefruit */
.color-left.grapefruit-light {
	background-color:#ED5565;
}
.color-right.grapefruit-dark {
	background-color:#DA4453;
}

/* Bittersweet */
.color-left.bittersweet-light {
	background-color:#FC6E51;
}
.color-right.bittersweet-dark {
	background-color:#E9573F;
}

/* Sunflower */
.color-left.sunflower-light {
	background-color:#FFCE54;
}
.color-right.sunflower-dark {
	background-color:#F6BB42;
}

/* Grass */
.color-left.grass-light {
	background-color:#A0D468;
}
.color-right.grass-dark {
	background-color:#8CC152;
}

/* Mint */
.color-left.mint-light {
	background-color:#48CFAD;
}
.color-right.mint-dark {
	background-color:#37BC9B;
}

/* Aqua */
.color-left.aqua-light {
	background-color:#4FC1E9;
}
.color-right.aqua-dark {
	background-color:#3BAFDA;
}

/* Blue Jeans */
.color-left.blueJeans-light {
	background-color:#5D9CEC;}
.color-right.blueJeans-dark {
	background-color:#4A89DC;
}

/* Lavander */
.color-left.lavander-light {
	background-color:#AC92EC;
}
.color-right.lavander-dark {
	background-color:#967ADC;
}

/* Pink Rose */
.color-left.pinkrose-light {
	background-color:#EC87C0;
}
.color-right.pinkrose-dark {
	background-color:#D770AD;
}

/* Light Gray */
.color-left.lightgray-light {
	background-color:#F5F7FA;
}
.color-right.lightgray-dark {
	background-color:#E6E9ED;
}

/* Medium Gray */
.color-left.mediumgray-light {
	background-color:#CCD1D9;
}
.color-right.mediumgray-dark {
	background-color:#AAB2BD;
}

/* Dark Gray */
.color-left.darkgray-light {
	background-color:#656D78;
}
.color-right.darkgray-dark {
	background-color:#434A54;
}
</style>